import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {
    constructor(
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!StorageService.checkStorage().getItem('_token')) {
            return true;
        }
        if (StorageService.checkStorage().getItem('_phone') || sessionStorage.getItem('_phone')) {
            this.router.navigate(['/documents-user/main/data']);
        } else {
            this.router.navigate(['/home']);
        }
        return false;
    }
}